export default [
    {
        path: '/revocation-condition/list',
        name: 'revocation_condition_list',
        component: () => import('@src/revocation-condition/revocation-condition-list.vue'),
        meta: {
            title: 'Artikelzustand',
            role: 'ROLE_SHOW_RETURN_GOODS_NOTIFICATION',
        },
    },
    {
        path: '/revocation-condition/create',
        name: 'revocation_condition_create',
        component: () => import('@src/revocation-condition/revocation-condition-create.vue'),
        meta: {
            title: 'Artikelzustand anlegen',
            role: 'ROLE_SHOW_RETURN_GOODS_NOTIFICATION',
        },
    },
    {
        path: '/revocation-condition/edit/:id',
        name: 'revocation_condition_edit',
        component: () => import('@src/revocation-condition/revocation-condition-edit.vue'),
        meta: {
            title: 'Artikelzustand bearbeiten',
            role: 'ROLE_SHOW_RETURN_GOODS_NOTIFICATION',
        },
        props({ params }) {
            return {
                id: Number.parseInt(params.id),
            };
        },
    },
];
